import { Progress } from '@repo/videa-components/src/index';

import { StatusChip } from '../../../../common-components/elements/StatusChip/StatusChip';
import type { StatusChipProps } from '../../../../common-components/elements/StatusChip/StatusChip';

interface BenefitsProgressProps {
  progress: number;
  total: number;
  title: string;
  progressColor?: string;
  chip?: StatusChipProps; // Optional chip to display to the right of the number line
  hideProgress?: boolean;
}

export const BenefitsProgress = ({
  progress,
  total,
  title,
  progressColor = 'vai-bg-green-600',
  chip,
  hideProgress = false,
}: BenefitsProgressProps) => {
  const percentage = total > 0 ? (progress / total) * 100 : 0;

  return (
    <div>
      <div className="vai-text-sm vai-font-medium vai-text-muted-foreground vai-uppercase vai-leading-small">
        {title}
      </div>
      <div className="vai-mt-3 vai-flex vai-items-center vai-justify-between">
        <div className="vai-flex vai-items-center vai-gap-2">
          <span className="vai-text-2xl vai-font-bold vai-text-foreground">
            $
            {progress.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
          <span className="vai-text-2xl vai-text-muted-foreground">/</span>
          <span className="vai-text-2xl vai-text-muted-foreground">
            $
            {total.toLocaleString('en-US', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </span>
        </div>
        {chip && <StatusChip {...chip} />}
      </div>
      {!hideProgress && (
        <div className="vai-mt-3">
          <Progress
            value={percentage}
            className="vai-h-[12px] vai-bg-zinc-300"
            indicatorClassName={progressColor}
          />
        </div>
      )}
    </div>
  );
};
